module.exports = __webpack_public_path__ + "img/Avatar-16.b4687133.svg";